import { initLDReactContext } from '@launchdarkly/react-sdk';

export const LaunchDarklyGlobalFlagsContext = initLDReactContext();
